import React from "react";
import { Spin } from "antd";
import "./style.less";

export default function Loading() {
  return (
    <div className="loadingComponent">
      <Spin size="large" />
    </div>
  );
}
